import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {CrossModule} from "../cross/cross.module";
import {MessageModule} from "primeng/message";
import {ReferPage} from "./page/refer-page/refer.page";
import {DialogModule} from "primeng/dialog";
import {ButtonModule} from "primeng/button";
import {RedeemStatusTranslatePipe} from "./pipes/RedeemStatusTranslatePipe";


@NgModule({
  declarations: [
    ReferPage,
    RedeemStatusTranslatePipe,
  ],
  exports:[
    ReferPage,
  ],
  imports: [
    CoreModule,
    CrossModule,
    MessageModule,
    DialogModule,
    ButtonModule,
  ]

})
export class CsModule { }

